module.exports = __webpack_public_path__ + "img/bit_withdraw_icon.4ae9b10c.svg";